import { Delete, House, Person } from "@mui/icons-material";
import { Button, Grid, IconButton, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import updateOrderApi from "../../../../../../api/public/storefronts/orders/update";
import ReservationDateRange from "../../../../../text/ReservationDateRange";
import DeleteConfirmation from "../../../../../form/DeleteConfirmation";
import OrderTip from "../../../../orders/OrderTip";
import useCheckoutStore from "../../../../../../stores/public/useCheckoutStore";

export default function OrderSummary({ order, reservations, handleRemoveReservation, showCheckoutButton, hideDelete, onCheckout}) {
  const navigate = useNavigate();

  const { setOrder } = useCheckoutStore();

  const handleCheckout = () => {
    onCheckout && onCheckout();
    navigate('checkout');
  };

  const handleTipUpdate = (tip) => {
    updateOrderApi(order.organization_id, order.id, { tip: tip }, (response) => {
      setOrder(response);
    });
  };

  return (
    <Stack spacing={2}>
      <Stack>
        <Typography variant="h5">
          Order Summary #{order.id}
        </Typography>
      </Stack>
      <Stack>
        {order.customer_id && <Grid container>
          <Grid item sm={1} display="flex">
            <IconButton size="small">
              <Person sx={{ my: "auto" }} />
            </IconButton>
          </Grid>
          <Grid item sm={11} display="flex">
            <Typography variant="h6" sx={{ my: "auto" }}>
              {order.customer.full_name}
            </Typography>
          </Grid>
        </Grid>}
        {order.location_id && <Grid container>
          <Grid item sm={1} display="flex">
            <IconButton size="small">
              <House sx={{ my: "auto" }} />
            </IconButton>
          </Grid>
          <Grid item sm={11} display="flex" flexDirection="column">
            <Typography variant="h6" sx={{ my: "auto" }}>
              {order.location.name}
            </Typography>
            <Typography variant="body1" sx={{ my: "auto" }}>
              {order.location.address_1}, {order.location.city}, {order.location.state} {order.location.zip}
            </Typography>
          </Grid>
        </Grid>}
      </Stack>
      {reservations.length > 0 && <Stack gap={2}>
        {reservations.map((reservation) => console.log(reservation) || (
          <Grid container key={reservation.id}>
            {!hideDelete && <Grid item sm={1}>
              <DeleteConfirmation handleDelete={() => handleRemoveReservation(reservation)}>
                <IconButton size="small">
                  <Delete />
                </IconButton>
              </DeleteConfirmation>
            </Grid>}
            <Grid item xs={10} sm={11}>
              <Stack key={reservation.id}>
                <Stack>
                  {reservation.start_at ? <ReservationDateRange reservation={reservation} hideTime={reservation.bookable_duration.duration_type === 'full_day'} />:
                  <Typography variant="body1" fontWeight="700">
                    Unscheduled reservation
                  </Typography>}
                </Stack>
                <Stack pl={1}>
                  {reservation.reservation_items?.map((reservationItem) => (
                    <Grid container key={reservationItem.id}>
                      <Grid item xs={6} sm={10}>
                        <Typography variant="body1">
                          {reservationItem.quantity}x {reservationItem.item?.name} ({reservation?.bookable_duration?.name})
                        </Typography>
                      </Grid>
                      <Grid item xs={6} sm={2} textAlign={{ xs: "right", sm: "left" }}>
                        <Typography variant="body1">
                          ${parseFloat(reservationItem.total_price_dollars).toFixed(2)}
                        </Typography>
                      </Grid>
                    </Grid>
                  ))}
                </Stack>
              </Stack>
            </Grid>
          </Grid>
        ))}
      </Stack>}
      <Stack>
        <Grid container>
          <Grid item sm={1}>

          </Grid>
          <Grid item sm={11}>
            <Grid container>
              <Grid item xs={6} sm={10}>
                <Typography variant="body1">
                  Service fee
                </Typography>
              </Grid>
              <Grid item xs={6} sm={2}>
                <Typography variant="body1">
                  ${parseFloat(order.total_fees).toFixed(2)}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={10}>
                <Typography variant="body1">
                  Taxes
                </Typography>
              </Grid>
              <Grid item xs={6} sm={2}>
                <Typography variant="body1">
                  ${parseFloat(order.total_tax_dollars).toFixed(2)}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Stack>
      <Stack>
        <Grid container>
          <Grid item xs={12} sm={8}>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Stack direction="row" width="100%">
              <OrderTip order={order} handleSubmit={handleTipUpdate} />
            </Stack>
          </Grid>
        </Grid>
      </Stack>
      <Stack>
        <Grid container>
          <Grid item xs={0} sm={8} />
          <Grid item xs={6} sm={2}>
            <Typography variant="h5" fontWeight="700">
              Total
            </Typography>
          </Grid>
          <Grid item xs={6} sm={2} textAlign={{ xs: "right", sm: "left" }}>
            <Typography variant="h5">
              ${parseFloat(order.grand_total_price_dollars).toFixed(2)}
            </Typography>
          </Grid>
        </Grid>
      </Stack>
      {showCheckoutButton && <Stack>
        <Stack>
          <Button onClick={handleCheckout} variant="contained" color="primary">
            Checkout
          </Button>
        </Stack>
      </Stack>}
    </Stack>
  );
}